import * as Html from "../util/Html.ts";
export {init}

Html.registerWidget('widget/accordion',{init:init})

function init(accordion,headerSelector,bodySelector){
  headerSelector = headerSelector || ".collapsible-header";
  bodySelector =  bodySelector || ".collapsible-body";
  
  accordion.find(bodySelector).each(function(idx,domNode){
    var body = $(domNode);
    body.css('box-sizing','border-box');
    body.css('overflow','hidden');
    body.css('height','0px');
    body.css('transition','height 0.35s linear');
  });
  accordion.on("click",headerSelector,function(){
    var 
      header = $(this),
      body = header.next(bodySelector);
    if(header.hasClass('accordion-open')){
      body.css('height',0);
      header.removeClass('accordion-open');
    }else{
      accordion.find('.accordion-open').removeClass('accordion-open');
      header.addClass('accordion-open');
      accordion.find(bodySelector).css('height',0);
      body.css('display','block');
      body.css('height',body.get(0).scrollHeight+"px");
    }
  });    
}